import React from 'react';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import FeedbackLocations from "components/Containers/FeedbackLocations";
import EngineerReviews from "components/Containers/EngineerReviews";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import Types from "../../../../../constants/Types";
import {Button} from "reactstrap";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";


const breadcrumbsStatic = [{
	name: 'Feedback',
	url: '/feedback',
	icon: 'dashboard',
}];

class Feedback extends Framework.Components.View {

	constructor(props) {
		super(props, 'locations');
		this.state = {
			location_data: [],
			review_data: [],
			tab: 'locations',
			filterDate: moment().day(0)
		};
	}

	async componentDidMount() {
		await this.loadLocations();
		await this.loadReviews()
	}

	loadLocations = async () => {
		let model = new API.BuildClass(Types.Feedback_Locations._name, API.RequestType.READ_ALL);
		this.data = await model.submit(null, "GET_ALL");
		this.data = this.data.items;
		this.setState({location_data: this.data});
	}

	loadReviews = async () => {
		this.setState({review_data: []})
		let model = new API.BuildClass(Types.Engineers_Reviews._name, API.RequestType.READ_ALL);
		model.filter = {
			'filterDate': this.state.filterDate
		}
		this.review_data = await model.submit(null, "GET_ALL");
		this.review_data = this.review_data.items;
		this.setState({review_data: this.review_data});
	}


	render() {
		let {
			match,
			history,
			roles,
		} = this.props;

		const startDate = this.state.filterDate ? moment(this.state.filterDate) : moment().day(0);
		const endDate = this.state.filterDate ? moment(this.state.filterDate).add(6, 'days') : moment().day(0).add(6, 'days');

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={async () => {
						this.setState({location_data: [], review_data: []})
						await this.loadLocations();
						await this.loadReviews();
					}} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Refresh Data
					</Button>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Locations" value="locations" data-cy={"calendar-tab"}/>
					<Tab label="Data Entry" value="entry" data-cy={'map-tab'}/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'locations'})}>
					{this.state.location_data.length > 0 && <FeedbackLocations
						data={this.state.location_data}
						isAdmin={roles.includes(UserRoles.Admin)}
						currentUser={this.props.rootState.name}
					/>}
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'entry'})}>
					<div className="table-bar">
						<div className={"row rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(7, 'days').format()}, async () => {
										await this.loadReviews();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({filterDate: moment().day(0)}, async () => {
										await this.loadReviews();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(7, 'days').format()}, async () => {
										await this.loadReviews();
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={"rbc-toolbar-label"}>
								<label>
									{startDate.format('MMMM D') + ' - ' + endDate.format('MMMM D')}
								</label>
							</div>
						</div>
					</div>
					{this.state.review_data.length > 0 ? <EngineerReviews
						data={this.state.review_data}
					/> : <b>There are no reviews for the selected week.</b>}
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Feedback);




